import {
  Box,
  Button,
  TextField
} from '@mui/material';
import CopyToClipboard from '@bumble/app/components/CopyToClipboard';
import { Loading } from '../Loading';

interface RouterGenerateTokenProps {
  generatedToken: string;
  loading: boolean;
  onClose: () => void;
}

export const RouterGenerateToken = ({ generatedToken, loading, onClose }: RouterGenerateTokenProps) => {

  return (
    <Box p={3}>
      {loading ? <Loading height={200} /> : (
        <Box position="relative" sx={{ mt: 2 }}>
          <TextField
            value={generatedToken}
            fullWidth
            multiline
            InputProps={{ readOnly: true }}
            sx={{pr: 20}}
          />
          <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
            <CopyToClipboard content={generatedToken} />
          </Box>
        </Box>
      )}
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </Box>
    </Box>
  );
};
